import { BaseRequest } from "../baseRequest";

export class RecentOptions extends BaseRequest {
  count?: number;
}